import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signInWithEmail } from '../services/supabase';
import './AdminLogin.css';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [redirectTo] = useState<string>(() => {
    // Try to get redirect path from query param
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') || '/book';
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
  await signInWithEmail(email, password);
  navigate(redirectTo);
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page enhanced-auth-bg">
      <form className="login-form enhanced-auth-card" onSubmit={handleSubmit}>
        <h2 className="enhanced-auth-title">Sign In</h2>
        <div className="enhanced-auth-group">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="enhanced-auth-input"
          />
        </div>
        <div className="enhanced-auth-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="enhanced-auth-input"
          />
        </div>
        {error && <div className="enhanced-auth-error">{error}</div>}
        <button type="submit" className="enhanced-auth-btn" disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
        <div className="enhanced-auth-footer">
          <span>Don't have an account? </span>
          <Link to={`/register?redirect=${encodeURIComponent(redirectTo)}`}>Register</Link>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
